import React, { useEffect, useState } from "react"; 
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import "@material/mwc-tab-bar/mwc-tab-bar.js";
import "@material/mwc-tab/mwc-tab.js";
import "@material/mwc-textfield/mwc-textfield.js";
import SecretKeyDecryption from "./secretKeyDecryption";
import { passwordEncrypt } from "./passwordEncryption"; 

  function EmployeeProfile(props) {

    const { fetchSecretKey } = SecretKeyDecryption();
  const { userid } = useParams();

  const [loader, setLoader] = useState(false);
  const [designations, setDesignations] = useState([]);
  const [gender, setGender] = useState([]);
  const [locations, setLocations] = useState([]);

  const[loading ,setLoading]=useState(false);
  const [password, setPassword] = useState('');
  const token = JSON.parse(localStorage.getItem("data")).token;
  

  const [profile, setProfile] = useState({
    name:"",
    lastname:"",
    phoneno:"",
    gender:"",
    dob:"",
    aadhaarnumber:"",
    companyId:"",
    email:"",
    address:"",
    pan:"",
    empid:"",
    designation:"",
    dateOfJoining:"",
    packagetype:"",
    locationId:"",
    peme:"",
    locations:{
      location:""
    },
    employeeProfileImage:{
      image:null,
      imageMeta:"",
    }
  });
  
  useEffect(() => {
    setLoading(true);
    
    const fetchProfile = async () => {
      try {
        const response = await axios.get(`/api/employeedetails/getEmployeeDetailsWithProfileImageByUserid/userid=${userid}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const userProfileDetails = response.data;
       setProfile(userProfileDetails);

       const des = await axios.get(`/api/designation/companyId=${response.data?.companyId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDesignations(des.data);
      const gender = await axios.get(`/api/gender`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setGender(gender.data);
      const loc = await axios.get(`/api/geolocation/companyId=${response.data?.companyId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLocations(loc.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
handleError(error);
      }
    };

    fetchProfile();

  }, [userid]);
  

  function getBase64FromFile(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
       const [metadata, content] = reader.result.split(",");
       resolve({ metadata, content });};
       reader.onerror = function (error) {
       reject(error);};}); }

       const handleImageChange = async (event) => {
        if (event.target.files && event.target.files[0]) {
          const convertedImage = await getBase64FromFile(event.target.files[0]);
      
          setProfile((prevState) => ({
            ...prevState,  // Keep all existing properties
            employeeProfileImage: {
              imageMeta: convertedImage.metadata,
              image: convertedImage.content,
            },
          }));
        }
      };
      
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      await axios.post(`/api/employeedetails/update`, profile, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Profile Updated Successfully");
      setLoading(false);

    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handlePasswordSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
        const decryptedSecretKey = await fetchSecretKey();
                    if (!decryptedSecretKey) {
                      setLoading(false);
                      return;
                    }
              
                    const encryptedPassword = await passwordEncrypt(password, decryptedSecretKey);
      const body = {
        id: profile.userid,
        password: encryptedPassword,
      };

      await axios.post(`/api/accounts/update-password`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Password Updated Successfully");
      setPassword("");
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  
const handleChange = (event, field) => {
    let actualValue = event.target.value;

    setProfile({ ...profile, [field]: actualValue });
    
  };

const navigate = useNavigate();
const handleBack = async (orgcode) => {
  navigate(`/users/companydetails/${orgcode}`);
};
  return (
    <div>
               
     {loading && <div className="loading"></div>} 
    
      {/* <div className="col-12 mx-xl-auto ps-xl-10">*/}
        <div className="mb-2">  
        <button className="btn btn-primary" onClick={() => handleBack(profile.companycode)}>
      Back
    </button>
        </div> 
        <div className="card card-raised">
          <div className="card-body">
            <div className="d-flex">
              <div className="card-title">Profile Details</div>{" "}
              <br/>
              <br/>
              <br/>
              <div >
                {profile.employeeProfileImage?.image ? (
                  <img
                    className="img-fluid circular-image mb-1"
                    id="image"
                    src={`${profile?.employeeProfileImage?.imageMeta},${profile?.employeeProfileImage?.image}`}
                    alt="User Profile"
                    style={{
                      width: "150px",
                      height: "150px",
                      display: "block",
                      borderRadius: "50%", // Use 50% border radius for a circular shape
                      background: "#ccc", // Set a background color for the icon
                      // textAlign: "center",
                      lineHeight: "170px",
                      fontSize: "24px",
                      // marginright: "60%",
                      marginTop:"60px",
                    }}
                  />
                ) : (
                  <div
                    className="img-fluid circular-image mb-1"
                    id="image"
                    style={{
                      width: "150px",
                      height: "150px",
                      display: "block",
                      borderRadius: "50%", // Use 50% border radius for a circular shape
                      background: "#ccc", // Set a background color for the icon
                      // textAlign: "center",
                      lineHeight: "170px",
                      fontSize: "24px",
                      // marginright: "60%",
                      marginTop:"60px",

                    }}
                  >
                    {/* <FaRegUserCircle size={250} /> */}
                  </div>
                )}
                <input
                  className="col-7"
                  type="file"
                  id="image"
                  // style={{ marginLeft: "10%" }}
                  onChange={(event) => {
                    console.log(event.target.files[0]);
                    handleImageChange(event);
                  }}
                  accept="image/*"
                />
              </div>
              <form onSubmit={handleSubmit}>
                <div className="row">
                <div className="col-md-6">

                  <div className="form-floating-sm mb-2">
                    <label for="organization">First Name :</label>
                    <input
                      className="form-control"
                      id="fisrtname"
                      type="text"
                      value={profile.name}
                      onChange={(e) => handleChange(e, "name")}
                    />
                  </div>
                </div>
                <div className="col-md-6">

                  <div className="form-floating-sm mb-2">
                    <label for="organization">Last Name :</label>
                    <input
                      className="form-control"
                      id="lastname"
                      type="text"
                      value={profile.lastname}
                      onChange={(e) => handleChange(e, "lastname")}
                    />
                  </div>
                </div>
                </div>
                <div className="row">
                <div className="col-md-6">

                  <div className="form-floating-sm mb-2">
                    <label for="phoneno">Phone Number :</label>
                    <input
                      className="form-control"
                      id="phoneno"
                      type="text"
                      value={profile.phoneno}
                      onChange={(e) => {
                        const inputText = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                        const limitedText = inputText.slice(0, 10); // Limit to 10 characters
                        setProfile({ ...profile, phoneno: limitedText }); // Update the state with limited text
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">

                  <div className="form-floating-sm mb-2">
                    <label for="organization">Email ID :</label>
                    <input
                      className="form-control"
                      id="email"
                      type="email"
                      value={profile.email}
                      readOnly
                      // onChange={(e) => handleChange(e,"email")}
                    />
                  </div>
                </div>
                </div>
                <div className="row">
                <div className="col-md-6">

                  <div className="form-floating-sm mb-2">
                    <label for="dob">Date Of Birth :</label>
                    <input
                      className="form-control"
                      id="dob"
                      type="date"
                      value={profile.dob}
                      onChange={(e) => handleChange(e, "dob")}
                    />
                  </div>
                </div>
                <div className="col-md-6">

                <div className="form-floating-sm mb-2">
                    <label htmlFor="gender">
                      Gender 
                    </label>
                    <select
                      className="form-select"
                      id="gender"
                      value={profile.gender}
                      onChange={(e) => handleChange(e, "gender")}
                      required
                    >
                      {/* <option value="">Select Gender</option> */}
                      {gender.map((cat) => (
                        <option key={cat.id} value={cat.gender}>
                          {cat.gender}
                        </option>
                      ))}
                    </select>
                    </div>
                </div>
                </div>
                <div className="row">
  <div className="col-md-6">
    <div className="form-floating-sm mb-2">
      <label htmlFor="empid">
        Employee Id: {profile.peme === true && <span className="text-muted">(Optional)</span>}
      </label>
      <input
        className="form-control"
        id="empid"
        type="text"
        value={profile.empid}
        onChange={(e) => handleChange(e, "empid")}
      />
    </div>
  </div>

  <div className="col-md-6">
    <div className="form-floating-sm mb-2">
      <label htmlFor="designation" className="d-flex justify-content-between">
        Designation {profile.peme === true && <span className="text-muted">(Optional)</span>}
        {!designations.some(cat => cat.designation === profile.designation) && (
          <span className="text-danger">Invalid Designation</span>
        )}
      </label>
      <select
        className="form-select"
        id="designation"
        value={
          designations.some(cat => cat.designation === profile.designation)
            ? profile.designation
            : ""
        }
        onChange={(e) => handleChange(e, "designation")}
        required={!profile.peme} // Make it required only when profile.peme is false
      >
        <option value="" disabled>
          Select Designation
        </option>
        {designations.map((cat) => (
          <option key={cat.id} value={cat.designation}>
            {cat.designation}
          </option>
        ))}
      </select>
    </div>
  </div>
</div>

<div className="row">
  <div className="col-md-6">
    <div className="form-floating-sm mb-2">
      <label htmlFor="dateOfJoining">
        Date of Joining: {profile.peme === true && <span className="text-muted">(Optional)</span>}
      </label>
      <input
        className="form-control"
        id="dateOfJoining"
        type="date"
        value={profile.dateOfJoining}
        onChange={(e) => handleChange(e, "dateOfJoining")}
      />
    </div>
  </div>

                <div className="col-md-6">
                  <div className="form-floating-sm mb-2">
                    <label for="pan">PAN :</label>
                    <input
                      className="form-control"
                      id="pan"
                      type="text"
                      value={profile.pan}
                      onChange={(e) => handleChange(e, "pan")}
                    />
                  </div>
                </div>
                </div>


                <div className="row">
                <div className="col-md-6">
                  <div className="form-floating-sm mb-2">
                    <label for="aadhaarnumber">Aadhar Number :</label>
                    <input
                      className="form-control"
                      id="aadhaarnumber"
                      type="text"
                      value={profile.aadhaarnumber}
                      onChange={(e) => handleChange(e, "aadhaarnumber")}
                    />
                  </div>
                </div>
               
                <div className="col-md-6">
                  <div className="form-floating-sm mb-2">
                    <label for="addressName">Address :</label>
                    <textarea
                      className="form-control"
                      id="addressName"
                      type="text"
                      value={profile.address}
                      onChange={(e) => handleChange(e, "address")}
                      rows="2"
                    />
                  </div>
                </div>

                <div className="row">
  <div className="col-md-6">
    <div className="form-floating-sm mb-2">
      <label htmlFor="locationId">Location :</label>
      <select
        className="form-select"
        id="locationId"
        value={profile.locationId || ""}
        onChange={(e) => handleChange(e, "locationId")}
      >
        {/* Default option to show "Select Location" */}
        <option value="" disabled>
          Select Location
        </option>
        {/* List all locations */}
        {locations.map((loc) => (
          <option key={loc.id} value={loc.id}>
            {loc.location}
          </option>
        ))}
      </select>
    </div>
  </div>
</div>


          
                {/* <div className="col-md-6">
  <div className="form-floating-sm mb-2">
    <label htmlFor="addressProof">Upload Address Proof</label>
    {handleFilePreview(profile.imageMeta, profile.addressProof)}

    <input
      className="form-control"
      id="addressProof"
      type="file" 
      onChange={(e) => handleImageChange0(e, "addressProof")} 
      accept="image/jpeg, image/png, application/pdf" 
    />
  </div>
</div>
                
               */}
                </div>

                      
                
                <br />
                <input
                  type="submit"
                  value="save changes"
                  className="btn btn-primary"
                />
              </form>
            </div>
          </div>
        </div>
      {/* </div> */}
      <br />
      {/* <div className="col-12 mx-xl-auto ps-xl-10">
        <div className="card card-raised">
          <div className="card-body">
            <div >
              <div className="card-title">Identification Details</div>
             <br/>
              <form onSubmit={handleSubmit1}>
               
                <div className="row">
                <div className="col-md-6">

                  <div className="form-floating-sm mb-2">
                    <label for="adharNumber">Aadhaar Number :</label>
                    <input
                      className="form-control"
                      id="adharNumber"
                      type="text"
                      value={profile1.adharNumber}
                      onChange={(e) => handleChange1(e, "adharNumber")}
                    />
                  </div>
                </div>
                <div className="col-md-6">
  <div className="form-floating-sm mb-2">
    <label htmlFor="adharProof">Upload Aadhaar</label>
    {handleFilePreview(profile1.adharMeta, profile1.adharProof)}

    <input
      className="form-control"
      id="adharProof"
      type="file" 
      onChange={(e) =>handleImageChange1(e, "adharProof")}
      accept="image/jpeg, image/png, application/pdf" 
      />
  </div>
</div>
                </div>

                <div className="row">
                <div className="col-md-6">

                  <div className="form-floating-sm mb-2">
                    <label for="panNumber">PAN Number :</label>
                    <input
                      className="form-control"
                      id="panNumber"
                      type="text"
                      value={profile1.panNumber}
                      onChange={(e) => handleChange1(e, "panNumber")}
                    />
                  </div>
                </div>
                <div className="col-md-6">
  <div className="form-floating-sm mb-2">
    <label htmlFor="panProof">Upload PAN </label>
    {handleFilePreview(profile1.panMeta, profile1.panProof)}

    <input
      className="form-control"
      id="panProof"
      type="file" 
      onChange={(e) => handleImageChange2(e, "panProof")} 
      accept="image/jpeg, image/png, application/pdf" 
      />
  </div>
</div>
                </div>

                <div className="row">
                <div className="col-md-6">

                  <div className="form-floating-sm mb-2">
                    <label for="dlNumber">Driving Licence :</label>
                    <input
                      className="form-control"
                      id="dlNumber"
                      type="text"
                      value={profile1.dlNumber}
                      onChange={(e) => handleChange1(e, "dlNumber")}
                    />
                  </div>
                </div>
                <div className="col-md-6">
  <div className="form-floating-sm mb-2">
    <label htmlFor="dlProof">Upload Driving Licence</label>
    {handleFilePreview(profile1.dlMeta, profile1.dlProof)}

    <input
      className="form-control"
      id="dlProof"
      type="file"
      onChange={(e) => handleImageChange3(e, "dlProof")} 
      accept="image/jpeg, image/png, application/pdf" 
      />
  </div>
</div>
                </div>
                <div className="row">
                <div className="col-md-6">

                  <div className="form-floating-sm mb-2">
                    <label for="passportNumber">Passport Number:</label>
                    <input
                      className="form-control"
                      id="passportNumber"
                      type="text"
                      value={profile1.passportNumber}
                      onChange={(e) => handleChange1(e, "passportNumber")}
                    />
                  </div>
                </div>
                <div className="col-md-6">

<div className="form-floating-sm mb-2">
  <label for="passportissuingcountry">Passport Issuing Country:</label>
  <input
    className="form-control"
    id="passportissuingcountry"
    type="text"
    value={profile1.passportissuingcountry}
    onChange={(e) => handleChange1(e, "passportissuingcountry")}
  />
</div>
</div>
                
                <div className="col-md-6">
  <div className="form-floating-sm mb-2">
    <label htmlFor="passportProof">Upload Passport</label>
    {handleFilePreview(profile1.passportMeta, profile1.passportProof)}

    <input
      className="form-control"
      id="passportProof"
      type="file"
      onChange={(e) => handleImageChange4(e, "passportProof")} 
      accept="image/jpeg, image/png, application/pdf" 
      />
  </div>
</div>
                </div>

                <br />
                <input
                  type="submit"
                  value="save changes"
                  className="btn btn-primary"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
      <br/>
      <div className="col-12 mx-xl-auto ps-xl-10">
        <div className="card card-raised">
          <div className="card-body">
            <div >
              <div className="card-title">Bank Details</div>
             <br/>
              <form onSubmit={handleSubmit2}>
               
                <div className="row">
                <div className="col-md-6">

                  <div className="form-floating-sm mb-2">
                    <label for="bankname">Name of Bank :</label>
                    <input
                      className="form-control"
                      id="bankname"
                      type="text"
                      value={profile2.bankname}
                      onChange={(e) => handleChange2(e, "bankname")}
                    />
                  </div>
                </div>
                <div className="col-md-6">

<div className="form-floating-sm mb-2">
  <label for="branch">Branch :</label>
  <input
    className="form-control"
    id="branch"
    type="text"
    value={profile2.branch}
    onChange={(e) => handleChange2(e, "branch")}
  />
</div>
</div>
                
                </div>

                <div className="row">
                <div className="col-md-6">

                  <div className="form-floating-sm mb-2">
                    <label for="branchcode">Branch Code :</label>
                    <input
                      className="form-control"
                      id="branchcode"
                      type="text"
                      value={profile2.branchcode}
                      onChange={(e) => handleChange2(e, "branchcode")}
                    />
                  </div>
                </div>
                <div className="col-md-6">

<div className="form-floating-sm mb-2">
  <label for="accountnumber">Account Number :</label>
  <input
    className="form-control"
    id="accountnumber"
    type="text"
    value={profile2.accountnumber}
    onChange={(e) => handleChange2(e, "accountnumber")}
  />
</div>
</div>
                
                </div>
                <div className="row">
                <div className="col-md-6">

                  <div className="form-floating-sm mb-2">
                    <label for="ifsccode">IFSC Code :</label>
                    <input
                      className="form-control"
                      id="ifsccode"
                      type="text"
                      value={profile2.ifsccode}
                      onChange={(e) => handleChange2(e, "ifsccode")}
                    />
                  </div>
                </div>
                <div className="col-md-6">

<div className="form-floating-sm mb-2">
  <label for="micrcode">MICR Code :</label>
  <input
    className="form-control"
    id="micrcode"
    type="text"
    value={profile2.micrcode}
    onChange={(e) => handleChange2(e, "micrcode")}
  />
</div>
</div>
                
                </div>
                <div className="row">
                <div className="col-md-6">

                  <div className="form-floating-sm mb-2">
                    <label for="swiftcode">SWIFT Code :</label>
                    <input
                      className="form-control"
                      id="swiftcode"
                      type="text"
                      value={profile2.swiftcode}
                      onChange={(e) => handleChange2(e, "swiftcode")}
                    />
                  </div>
                </div>
              
                
                </div>

               

                <br />
                <input
                  type="submit"
                  value="save changes"
                  className="btn btn-primary"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
      <br/> */}
     
       {/* Password Update Card */}

       <div className="card card-raised">
          <div className="card-body">
            <div className="card-title text-center mb-2">Update Password</div>
            <form className="d-flex justify-content-center" onSubmit={handlePasswordSubmit}>
            <div className="col-md-6 mt-2">
              <div className="form-floating-sm mb-2">
                <label htmlFor="currentPassword">New Password :</label>
                <input
                  className="form-control"
                  id="password"
                  type="password"
                  placeholder="Enter new Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>
            <div className="row justify-content-center">
          <div className="col-md-6 text-center mt-4">
            <button type="submit" className="btn btn-primary">Update</button>
          </div>
        </div>
          </form>
          </div>
        </div>
    
 {/* <br/>
 <div className="col-12 mx-xl-auto ps-xl-10">
        <div className="card card-raised">
          <div className="card-body">
            <div >
              <div className="card-title">Family details</div>{" "}
              <button className="btn btn-primary float-end"
              onClick={handleAddFamily} >Add</button>
              <br />
              <br/>
              <br />
              <table className="table table-bordered" style={{position:"relative"}}>
                <thead>
                  <tr style={{fontSize:"17px", backgroundColor:"#6200ea", color:"white", textAlign:"center"}}>
                    <th>Name </th>
                    <th>Date of Birth</th>
                    <th>Gender</th>
                    <th>Phone Number</th>
                    <th>Relationship Status</th>
                    <th>Martial Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                {member.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center">
                No Data Available
              </td>
            </tr>
          ) : (
                  member.map((members, index) => {
                    return (
                      <tr key={index}>
                        <td>{members.name}</td>
                        <td>{members.dob}</td>
                        <td>{members.gender}</td>
                        <td>{members.phoneNumber}</td>
                        <td>{members.relationship}</td>
                        <td>{members.maritalstatus}</td>
                        <td> 
                     <button
                      onClick={() => handleEdit(members.id)}
                  style={{
                         border: "none",
                         background: "white",
                         size: "150px",
                       }}
                     >
                       <BiEditAlt />
                     </button>
                     <button
                          style={{
                            border: "none",
                            background: "white",
                            color: "grey",
                            position: "relative",
                            left: "20px",
                            fontSize: "30px",
                          }}
                          onClick={(e) => {
                            onClickhandler(
                              e,
                              members.id,
                            );
                          }}
                        >
                          <MdDeleteForever />
                        </button>{" "}
                       
                      
                   </td>
                      </tr>
                    );
                  }))}
                </tbody>
              </table>
              </div>
              <AddFamily isOpen={isModalOpen} onRequestClose={handleCloseModal} />
              {isEditModalOpen && (
              <FamilyeditModalPopup
                isOpen={isEditModalOpen}
                onRequestClose={closeEditModal}
                Id={selectedProductId}
              />
            )}
              </div>
    </div>
    </div> */}
    </div>
  );
}
 
export default EmployeeProfile;